/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./applyCopiedConfig.vue?vue&type=template&id=7231948b"
import script from "./applyCopiedConfig.vue?vue&type=script&lang=js"
export * from "./applyCopiedConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports